import React, { useMemo } from "react";

const CommonHeader = ({ text, icon, subText = "", actionButton }) => {
  const headerStyle = useMemo(
    () => ({
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "200px",
      background: "linear-gradient(90.91deg, #2B76FA 1.55%, #022A4E 57.62%)",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      padding: "0 20px",
    }),
    []
  );

  return (
    <div className="d-flex" style={headerStyle}>
      <div
        className="d-flex flex-column justify-content-center mx-20"
        style={{ height: "100%" }}
      >
        <h1 className="fw-bold text-white">{text}</h1>
        <h4 className="text-white">{subText}</h4>
      </div>
      <div
        className="mx-20 mb-2"
        style={{
          alignSelf: "flex-end",
        }}
      >
        <img
          src={icon}
          width={300}
          style={{
            objectFit: "contain",
            display: "block",
          }}
          alt="Header Icon"
        />
      </div>
      {actionButton && <div>{actionButton}</div>}
    </div>
  );
};

export default CommonHeader;
